import React from "react";
import { Briefcase, Gavel } from "lucide-react";

export const isJobOnHand = (t) => t === "job_on_hand";

export const RfqTypeBadge = ({ type, testid = "rfq-type-badge" }) =>
  isJobOnHand(type) ? (
    <span data-testid={testid}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-amber-100 dark:bg-amber-900/40 text-amber-900 dark:text-amber-200 border border-amber-300/70 text-[11px] font-extrabold uppercase tracking-wide">
      <Briefcase className="w-3 h-3" /> Job on hand
    </span>
  ) : (
    <span data-testid={testid}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-secondary text-muted-foreground text-[11px] font-bold uppercase tracking-wide">
      <Gavel className="w-3 h-3" /> Tender
    </span>
  );

export const RfqTypePicker = ({ value, onChange, testidPrefix = "rfq-type" }) => (
  <div className="inline-flex p-1 bg-secondary rounded-xl w-full">
    {[["tender", "Tender"], ["job_on_hand", "Job on hand"]].map(([id, label]) => (
      <button
        key={id}
        type="button"
        data-testid={`${testidPrefix}-${id}`}
        onClick={() => onChange(id)}
        className={`flex-1 px-4 h-9 rounded-lg text-sm font-bold transition-colors ${
          value === id ? "bg-card shadow-sm text-primary" : "text-muted-foreground hover:text-foreground"}`}
      >
        {label}
      </button>
    ))}
  </div>
);
